import { render } from "./VendorsChargesIndex.vue?vue&type=template&id=4eb34fc2"
import script from "./VendorsChargesIndex.vue?vue&type=script&lang=js"
export * from "./VendorsChargesIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__